export const NOTION_HOST = 'https://www.notion.so'

export const NOTION_ARBITRATION_ENGINE_PAGE_ID = '6bef034cc07848789536ea1e8a4f9bbc'
